import React, { useState } from "react";

const EditablePeopleField = ({group,index,saveGroup,deletePerson}) => {

  const [personName, setValue] = useState(group.people[index]);
  const [isEditing, setIsEditing] = useState(false);

  const handleApprove = () => {
    const people = group.people;
    let newPeople = people;
    newPeople[index] = personName;
    console.log("index:" + index);
    console.log("personName:" + personName);
    let updatedGroup = {...group, people: newPeople}
    const updatedGroup2 = updatedGroup;
    console.log("handleApprove:");
    console.log(updatedGroup2.people);
    saveGroup(updatedGroup2);
    setIsEditing(false);
  };
  const handleDelete = () =>{
    deletePerson(group.people,index);
  }
/*
  const handleReject = () => {
 
    setValue("");
    setIsEditing(false);
  };*/

  return (
    <div style={{ marginBottom: "1em",height:"30px" }}>
  
      {isEditing ? (
        <>
          <input
            value={personName}
            onChange={(e) => setValue(e.target.value)}
            style={{ marginRight: "0.5em",  marginLeft: "0.5em", float:"left",width: "70%", border: "1px solid", borderRadius:"2px" }}
          />
          <button onClick={handleApprove} style={{ marginRight: "0.5em",float:"left"}}>
          &#10004;
          </button>
         
        </>
      ) : (
        <>
          <span style={{marginLeft :"0.5em", float:"left",width: "60%"}}>{personName || <>&nbsp;</>}</span>
          <button onClick={() => setIsEditing(true)} style={{ marginLeft: "0.5em",float:"left",width: "25px" }}>
          &#9998;
          </button>
          <button onClick={handleDelete} style={{float:"left"}}>&#10060;</button>
        </>
      )}
    </div>
  );
};

export default EditablePeopleField;
